export const AppLoadingScreen = () => (
  <img
    style={{
      width: '100%',
      height: '100%',
      objectFit: 'contain',
    }}
    src="loading.png"
  />
)
